import React from 'react';
import { Modal, ModalBody } from 'reactstrap';
// jobmodal
const JobSuccessModal = ({
  isOpen,
  toggle,
  container = 'home-page',
  message,
  onRefresh,
  jobResponseData = {},
}) => {
  const handleClose = () => {
    toggle();
    // Refresh the page when modal is closed
    if (onRefresh) {
      onRefresh();
    } else {
      window.location.reload();
    }
  };

  // Extract data from jobResponseData with defensive coding
  const jobUrl = jobResponseData?.url || null;
  const userEmail = jobResponseData?.email || null;
  const jobType = jobResponseData?.jobType || null;
  const jobId = jobResponseData?.jobId || null;
  const token = jobResponseData?.token || null;
  const jobUUID = jobResponseData?.jobUUID || null;

  const needsPasswordCreation = jobUrl && jobUrl.includes('create-password');
  const hasValidUrl = jobUrl && jobUrl !== 'null' && jobUrl !== null;

  const handleCreatePassword = () => {
    if (hasValidUrl) {
      window.location.href = jobUrl;
    }
  };

  const handleLogin = () => {
    if (hasValidUrl) {
      window.location.href = jobUrl;
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={handleClose} container={container} className="modal-md">
      <button
        type="button"
        onClick={handleClose}
        style={{
          position: 'absolute',
          top: '-15px',
          right: '-15px',
          width: '45px',
          height: '45px',
          borderRadius: '50%',
          backgroundColor: '#fff',
          border: 'none',
          boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
          fontSize: '26px',
          fontWeight: 'bold',
          color: '#000',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000,
        }}
      >
        &times;
      </button>
      <ModalBody>
        <div className="text-center p-4">
          <div className="mb-4" style={{ fontSize: '4rem' }}>
            <i className="fa fa-check-circle text-success"></i>
          </div>
          <h3 className="text-success mb-3" style={{ fontWeight: 'bold' }}>
            Success!
          </h3>
          <div style={{ fontSize: '1.6rem', lineHeight: '1.6', marginBottom: '25px' }}>
            {message ? (
              <p>{message}</p>
            ) : (
              <>
                {/* <p>Hello Client,</p> */}

                <p>
                  Thank you for posting your <strong>{jobType || 'job'}</strong> job on GoAgent. You
                  can follow the clearing agents real-time bidding on your job{' '}
                  <strong>({jobId || 'N/A'})</strong> by logging into your account through the link
                  below. Thank you.
                </p>
              </>
            )}
          </div>

          <div
            className="mt-4 d-flex justify-content-center align-items-center"
            style={{ gap: '15px', flexWrap: 'wrap' }}
          >
            {needsPasswordCreation && hasValidUrl && (
              <button
                type="button"
                className="custom-close-btn btn-close-md btn-primary"
                onClick={handleCreatePassword}
                style={{
                  border: '2px solid #007679',
                  color: 'white',
                  backgroundColor: '#007679',
                  padding: '10px 15px',
                  borderRadius: '38px',
                  fontSize: '20px',
                  fontWeight: '500',
                }}
              >
                Login
              </button>
            )}

            {!needsPasswordCreation && hasValidUrl && jobUrl && (
              <button
                type="button"
                className="custom-close-btn btn-close-md btn-primary"
                onClick={handleLogin}
                style={{
                  border: '2px solid #007679',
                  color: 'white',
                  backgroundColor: '#007679',
                  padding: '10px 15px',
                  borderRadius: '38px',
                  fontSize: '20px',
                  fontWeight: '500',
                }}
              >
                Login
              </button>
            )}
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default JobSuccessModal;
